const baseUrl = (
  process.env.REACT_APP_S3_PUBLIC_MEDIA_BASE ||
  'https://nest-backend-autopilotee-cars.s3.us-east-2.amazonaws.com'
).replace(/\/$/, '');
export const URLS = {
  S3_BUCKET: {
    CAR_THUMBNAILS: `${baseUrl}`,
    TRIP_PHOTOS: `${baseUrl}`,
    DAMAGE_CLAIMS: `${baseUrl}/damage-claims`,
    DL_VERIFICATION: `${baseUrl}`,
  },
};
